import PageLayout from '@/components/feature/PageLayout';
import GalleryLightbox from './components/GalleryLightbox';

const galleryImages = [
  {
    src: 'https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/1645a6b3-346b-457a-9653-4f825a947016_compressed_Final-2--lart-de-creer-lunique.webp',
    alt: 'Meuble vasque sur mesure avec étagères et lave-linge intégré',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/9e3e1d02-fb92-450e-b358-b5fb3e5150b2_compressed_Final-2-bis-lart-de-creer-lunique.webp',
    alt: 'Meuble vasque sur mesure vue de profil avec lave-linge',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/a43aa65a-396d-4bd6-b0b7-a4186e233267_compressed_Final-lart-de-creer-l-unique--Sol-graphique-imitation-OSB-en-chevrons.webp',
    alt: 'Sol graphique imitation OSB en chevrons noir et bois',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/097aa8b4-241b-477f-b27a-32561f23269c_compressed_Final-lart-de-creer-lunique--motif-et-composition-Douche-Carrelage-Hexagonale.webp',
    alt: 'Douche avec carrelage hexagonal motif bois noir et blanc',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/0e4a6940-eb66-48f0-9150-82341eb76169_compressed_Final-lart-de-creer-lunique-crea-Vasque-vue-du-dessus.webp',
    alt: 'Vasque sur mesure vue du dessus avec robinetterie',
  },
];

const integrationImages = [
  {
    src: 'https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/2d225d6b-992c-48f6-9a15-2e3d5845023b_compressed_Final--lart-de-lintegration-Crea-Niche-douche.webp',
    alt: 'Niche de douche sur mesure intégrée',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/b13acb69-1041-4897-892a-61fd2f4cb2f6_compressed_Final-1---lart-de-lintegration---Grande.webp',
    alt: 'Vue d\'ensemble création sur mesure intégration parfaite',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/f00c00c4-77ee-4828-8234-8cfff466546e_compressed_Final-1bis--lart-de-lintegration.webp',
    alt: 'Détail intégration sur mesure',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/e8412fb8-06d4-475e-bf40-1a60b096d2ed_compressed_Final-lart-de-lintegration-vue-caniveau-entier-piscine-1.webp',
    alt: 'Caniveau de piscine sur mesure vue d\'ensemble',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/2d303070-1511-40b8-9c36-63bd4b96f7db_compressed_Finale-lart-de-lintegration--Zoom-sur-trou-du-caniveau-piscine-1-bis.webp',
    alt: 'Zoom sur le caniveau de piscine intégré',
  },
];

const innovationImages = [
  {
    src: 'https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/833bc348-4bc0-4ebb-bb9d-7db1ffde81e8_compressed_Final-innovation--savoir-faire-romu-en-action.webp',
    alt: 'Romuald en action sur chantier',
  },
];

export default function CreationsSurMesure() {
  return (
    <PageLayout>
      <section className="relative overflow-hidden min-h-screen bg-black">
        <div className="max-w-6xl mx-auto px-6 md:px-10 pt-6 md:pt-10 pb-16 md:pb-24 text-center">
          <h1 className="font-heading text-5xl md:text-7xl text-white leading-none text-center mx-auto px-4 max-w-full md:max-w-4xl">
            Bien plus que du carrelage Une signature
          </h1>

          <div className="mt-[4.55rem] md:mt-[6.5rem] max-w-2xl mx-auto space-y-8">
            <div className="bg-white rounded-2xl p-8 md:p-10 space-y-4">
              <p className="text-gray-800 leading-normal tracking-wide text-lg md:text-xl text-left font-avenir">
                Parce que les plus belles réalisations se distinguent par leurs détails, Romuald imagine et réalise des créations entièrement sur mesure. Tout commence par une idée. Entre les mains de Romuald, elle devient réalité : meubles vasques, baignoires, mobilier et éléments décoratifs, pensés pour trouver naturellement leur place dans votre intérieur.
              </p>
              <p className="text-gray-800 leading-normal tracking-wide text-lg md:text-xl text-left font-avenir">
                Jusqu'aux prises et interrupteurs intégrés, chaque finition est exécutée avec une précision millimétrique afin de préserver la pureté des lignes et l'équilibre de chaque espace.
              </p>
              <p className="text-gray-800 leading-normal tracking-wide text-lg md:text-xl text-left font-avenir">
                Chaque création est pensée pour révéler un intérieur qui vous ressemble.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 md:p-10 text-left">
              <p className="text-gray-800 leading-normal tracking-wide text-lg md:text-xl font-avenir">
                <strong>L'ART DE CREER L'UNIQUE</strong><br />Chaque création trouve naturellement sa place dans l'architecture. Meubles, vasques et compositions sur mesure révèlent une identité unique
              </p>
              <p className="text-gray-500 text-xs italic mt-3 mb-1">Cliquez pour agrandir</p>
              <GalleryLightbox images={galleryImages} />
            </div>

            <div className="bg-white rounded-2xl p-8 md:p-10 text-left">
              <p className="text-gray-800 leading-normal tracking-wide text-lg md:text-xl font-avenir">
                <strong>L'ART DE L'INTEGRATION</strong><br />L'intégration parfaite ne se remarque presque pas. Chaque détail s'efface naturellement au profit de la pureté des lignes
              </p>
              <p className="text-gray-500 text-xs italic mt-3 mb-1">Cliquez pour agrandir</p>
              <GalleryLightbox images={integrationImages} separatorIndices={[0, 2]} />
            </div>

            <div className="bg-white rounded-2xl p-8 md:p-10 text-left">
              <p className="text-gray-800 leading-normal tracking-wide text-lg md:text-xl font-avenir">
                <strong>INNOVATION & SAVOIR FAIRE</strong><br />L'innovation naît d'un regard différent. Chaque détail est pensé pour transformer l'imagination en réalité
              </p>
              <p className="text-gray-500 text-xs italic mt-3 mb-1">Cliquez pour agrandir</p>
              <GalleryLightbox images={innovationImages} />
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}